module.exports = __webpack_public_path__ + "img/vevo.4cb99d22.png";